export const ROOT = '/',
  PREASSESSED_ROOT = '/apply-for-a-loan',
  ABOUT_YOUR_APPLICATION = '/about-application',
  YOUR_LOAN_OPTIONS = '/make-loan',
  YOUR_LOAN_PURPOSE = '/loan-for',
  CONSOLIDATE_YOUR_DEBT = '/debt-consolidation',
  SOLE_INITIAL_QUESTIONS = '/initial-questions',
  USE_OF_PERSONAL_INFORMATION = '/use-personal-info',
  YOUR_FINANCIAL_CIRCUMSTANCES = '/financial-circumstances',
  YOUR_CHANGING_FINANCIAL_CIRCUMSTANCES = '/change-financial-circumstances',
  CREDIT_CARD_DETAILS = '/credit-card-details',
  EMPLOYMENT_DETAILS = '/employment-details',
  CHOOSE_A_USERNAME = '/choose-user-name',
  YOUR_MAIN_BANK_ACCOUNT = '/main-bank-account',
  DIRECT_DEBIT_INSTRUCTIONS = '/direct-debit-instructions',
  REVIEW_YOUR_LOAN_DETAILS = '/review-loan-details',
  INFORMATION_ABOUT_YOUR_LOAN = '/information-about-loan',
  YOUR_LOAN_APPROVAL = '/loan-approval',
  YOUR_LOAN_AGREEMENT_POST_CONTRACT = '/take-loan-agreement',
  YOUR_LOAN_AGREEMENT_PRE_CONTRACT = '/take-loan-pre-contract',
  YOUR_LOAN_AGREEMENT = '/take-loan',
  CHECKING_YOUR_IDENTITY = '/checking-identity',
  VERIFYING_YOUR_IDENTITY = '/identity-verification',
  CONGRATULATIONS = '/congrat',
  JOINT_APPLICATION_SUBMISSION = '/app-submission',
  JOINT_INITIAL_QUESTION = '/joint-initial-question',
  YOUR_SIGNATURE_IS_NEEDED = '/need-signature',
  ERROR = '/error',
  CREDIT_CHECK_DECLINE = '/credit-check-decline',
  ID_CHECK_CAN_NOT_DONE = '/id-check-failed',
  CREDIT_CHECK_REFERRED = '/credit-check-referred',
  CONFIRM_AUTH_CODE = '/confirm-auth-code',
  CREDIT_CHECK_REFERRED_POI = '/credit-check-referred-poi',
  CREDIT_CHECK_REFERRED_NO_MATCH = '/credit-check-referred-no-match',
  CREDIT_CHECK_REFERRED_BANK_CHECK = '/credit-check-referred-bank-check',
  CREDIT_CHECK_REFERRED_BANK_CHECK_POI = '/credit-check-referred-bank-check-poi',
  GET_IN_TOUCH = '/get-in-touch',
  CONFIRM_CODE = '/confirm-code',
  DOCUMENT_RECEIVED = '/document-received',
  INFORM_CHOICE = '/inform-choice',
  ABOUT_YOUR_LOAN_INFO = '/about-your-loan-info',
  INTERNAL_DEBT_CONSOLIDATE = '/internal-debt-consolidation',
  BEFORE_YOUR_SCREEN = '/before-your-screen',
  INELIGIBILTY_SCREEN = '/ineligibility-screen',
  ACCOUNT_LIST_SCREEN = '/account-list-screen',
  DOCUMENTS_ON_WAY = '/documents-on-way',
  JOINT_BEFORE_YOUR_SCREEN = '/joint-before-your-screen',
  CONFIRM_JOINT_LINK_CODE = '/confirm-joint-link-code',
  SUBMISSION_HOLDING_SCREEN = '/submission-holding-screen',
  DUPLICATE_CUSTOMER_ERROR = '/duplicate-customer',
  WARNING_MESSAGE_SCREEN = '/warning',
  USER_TIMED_OUT = '/user-timed-out',
  // Customer Information Routes
  REVIEW_YOUR_DETAILS = '/review-your-details',
  INCOME_AND_EXPENSES = '/income-and-expenses',
  MARKETING_PREFERENCES = '/your-marketing-preferences',
  YOUR_EMPLOYMENT_DETAILS = '/your-employment-details',
  YOUR_CONTACT_DETAILS = '/your-contact-details',
  YOUR_ADDRESS_DETAILS = '/your-address-details',
  YOUR_PERSONAL_DETAILS = '/your-personal-details',
  /** Decision In Principle Paths */
  DIP_PERSONAL_DETAILS = '/dip-personal-details',
  DIP_ADDRESS_DETAILS = '/dip-your-address-details',
  DIP_EMPLOYMENT_DETAILS = '/dip-employment-details',
  DIP_ABOUT_THIS_CHECK = '/dip-about-this-check',
  DIP_GREAT_NEWS = '/dip-great-news',
  DIP_UNLIKELY_RESULT = '/dip-unlikely-result',
  DIP_NO_MATCH = '/dip-no-match',
  DIP_REVIEW_DETAILS = '/dip-review-details',
  /**
   * NTB "Post-DIP Review Details" screen
   */
  POST_DIP_REVIEW_DETAIL = '/post-dip-review-details',
  /**
   * NTB "Post DIPReview" edit screens
   * ----------------------------------
   */
  POST_DIP_EDIT_ADDRESS_DETAILS = '/dip-edit-address-details',
  POST_DIP_EDIT_EMPLOYMENT_DETAILS = '/dip-edit-employment-details',
  POST_DIP_EDIT_INCOME_DETAILS = '/dip-edit-income-details',
  POST_DIP_EDIT_PERSONAL_DETAILS = '/dip-edit-personal-details',
  POST_DIP_EDIT_CONTACT_DETAILS = '/dip-edit-contact-details',
  // -----
  DIP_YOUR_LOAN_OPTIONS = '/dip-make-loan',
  DIP_YOUR_LOAN_PURPOSE = '/dip-loan-for',
  DIP_CONTACT_DETAILS = '/dip-contact-details',
  DIP_MARKETING_PREFERENCES = '/dip-marketing-preferences',
  DIP_YOUR_MAIN_BANK_ACCOUNT = '/dip-main-bank-account',
  DIP_DIRECT_DEBIT_INSTRUCTIONS = '/dip-direct-debit-instructions',
  DIP_REVIEW_YOUR_LOAN_DETAILS = '/dip-review-loan-details',
  DIP_INFORMATION_ABOUT_YOUR_LOAN = '/dip-information-about-loan',
  NTB_DIP_HOOYU_DRAWDOWN = '/dip-hooyu-drawdown',
  NTB_DIP_HOOYU_UNAVAILABLE = '/dip-hooyu-unavailable',
  NTB_DIP_KEEPING_YOU_SAFE = '/dip-keeping-you-safe',
  NTB_DIP_KEY_FEATURES = '/dip-key-features',
  NTB_DIP_DECLARATION_AND_AUTHORISATION = '/dip-declaration-and-authorisation',
  NTB_DIP_USE_OF_PERSONAL_INFORMATION = '/dip-use-of-personal-information',
  NTB_DIP_IDV_DECLINE = '/dip-loan-decision-decline';
